module.exports = __webpack_public_path__ + "static/img/P4.7fc47ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/leishenx/P4.png
// module id = PP5k
// module chunks = 0